import React from "react";

export interface NoResultProps {
  /** Primary heading */
  line_1?: string;
  /** Supporting text */
  line_2?: string;
  /** Override the default SVG illustration with any React node */
  icon?: React.ReactNode;
  "data-testid"?: string;
}

/** Default inline SVG — two stacked documents with a magnifier, no external deps */
const DefaultIllustration: React.FC = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Back document */}
    <rect
      x="17" y="9" width="24" height="30" rx="3"
      fill="var(--ntcog-primary)" fillOpacity="0.07"
      stroke="var(--ntcog-primary)" strokeOpacity="0.18" strokeWidth="1.4"
    />
    {/* Front document */}
    <rect
      x="12" y="14" width="24" height="30" rx="3"
      fill="var(--ntcog-surface, #F3F4F6)"
      stroke="var(--ntcog-primary)" strokeOpacity="0.28" strokeWidth="1.4"
    />
    {/* Content lines — fade out progressively */}
    <line x1="18" y1="23" x2="30" y2="23" stroke="var(--ntcog-primary)" strokeOpacity="0.4"  strokeWidth="1.5" strokeLinecap="round" />
    <line x1="18" y1="28" x2="27" y2="28" stroke="var(--ntcog-primary)" strokeOpacity="0.27" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="18" y1="33" x2="24" y2="33" stroke="var(--ntcog-primary)" strokeOpacity="0.14" strokeWidth="1.5" strokeLinecap="round" />
    {/* Magnifier body */}
    <circle
      cx="41" cy="42" r="7"
      fill="var(--ntcog-primary)" fillOpacity="0.07"
    />
    <circle
      cx="39" cy="40" r="5"
      stroke="var(--ntcog-primary)" strokeOpacity="0.55" strokeWidth="2" fill="none"
    />
    {/* Magnifier handle */}
    <line
      x1="43" y1="44" x2="47" y2="48"
      stroke="var(--ntcog-primary)" strokeOpacity="0.55" strokeWidth="2.2" strokeLinecap="round"
    />
    {/* Accent dots */}
    <circle cx="8"  cy="18" r="1.5" fill="var(--ntcog-primary)" fillOpacity="0.14" />
    <circle cx="49" cy="15" r="1.2" fill="var(--ntcog-primary)" fillOpacity="0.12" />
    <circle cx="6"  cy="42" r="1"   fill="var(--ntcog-primary)" fillOpacity="0.10" />
  </svg>
);

const NoResult: React.FC<NoResultProps> = ({
  line_1 = "Nothing to show",
  line_2 = "Try adjusting your search or filters.",
  icon,
  "data-testid": testId,
}) => (
  <div
    className="ntcog-empty"
    data-testid={testId ?? "empty-state"}
    role="status"
    aria-live="polite"
  >
    <div className="ntcog-empty__visual" aria-hidden="true">
      <div className="ntcog-empty__orb">
        {icon ?? <DefaultIllustration />}
      </div>
    </div>
    <p className="ntcog-empty__title">{line_1}</p>
    <p className="ntcog-empty__subtitle">{line_2}</p>
  </div>
);

export default NoResult;
